/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Requirement } from '../models/Requirement';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RequirementsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create
     * Create from parameters.
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns Requirement Successful Response
     * @throws ApiError
     */
    public createRequirementsPost(
        requestBody: Requirement,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Requirement> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/requirements',
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read
     * Get from ID.
     * @param itemId
     * @param designId
     * @param designInstanceId
     * @returns Requirement Successful Response
     * @throws ApiError
     */
    public readRequirementsItemIdGet(
        itemId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Requirement> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/requirements/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * Update with new parameters.
     * @param itemId
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns Requirement Successful Response
     * @throws ApiError
     */
    public updateRequirementsItemIdPut(
        itemId: string,
        requestBody: Requirement,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Requirement> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/requirements/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete
     * Delete by ID.
     * @param itemId
     * @param designId
     * @param designInstanceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteRequirementsItemIdDelete(
        itemId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/requirements/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
}
